import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const links = [
  { label: "Discord", href: "https://discord.com", icon: "D" },
  { label: "Steam", href: "https://steamcommunity.com/profiles/76561198782390625/", icon: "S" },
  { label: "Instagram", href: "https://www.instagram.com/aeon_dprt/", icon: "I" },
  { label: "Top", href: "#top", icon: "↑" },
];

export default function FloatingMenu() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-20 right-4 md:right-6 z-50">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 10 }}
            transition={{ duration: 0.2 }}
            className="absolute bottom-14 right-0 space-y-2"
          >
            {links.map((l, i) => (
              <motion.a
                key={l.label}
                href={l.href}
                target={l.href.startsWith("http") ? "_blank" : undefined}
                rel={l.href.startsWith("http") ? "noopener noreferrer" : undefined}
                initial={{ opacity: 0, x: 10 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: i * 0.05 }}
                className="flex items-center gap-2 bg-[#09090b]/90 border border-white/10 px-3 py-2 font-mono text-[10px] uppercase tracking-[0.15em] text-white/60 hover:text-[#F47B20] hover:border-[#F47B20]/30 transition-all duration-200 backdrop-blur-sm whitespace-nowrap"
              >
                <span className="w-5 h-5 flex items-center justify-center border border-white/10 text-[8px] text-[#F47B20]">
                  {l.icon}
                </span>
                {l.label}
              </motion.a>
            ))}
          </motion.div>
        )}
      </AnimatePresence>

      <button
        onClick={() => setOpen(!open)}
        className={`w-10 h-10 border flex items-center justify-center transition-all duration-300 ${
          open
            ? "border-[#F47B20] bg-[#F47B20] text-black rotate-45"
            : "border-white/20 bg-[#09090b]/80 text-[#F47B20] hover:border-[#F47B20]/50"
        } backdrop-blur-sm`}
      >
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5">
          <line x1="7" y1="2" x2="7" y2="12" />
          <line x1="2" y1="7" x2="12" y2="7" />
        </svg>
      </button>
    </div>
  );
}
